const routes = [
    {
        path: "/ticket/event/promotion/code",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "ticketeventpromotioncode_index"
        }
    },

];

export default routes;
